import employeeValidator from './employeeValidator';
import phoneValidator from './phoneValidator';
import nameValidator from './nameValidator';
import addressValidator from './addressValidator';
import wa10memberValidator from './wa10memberValidator';

const Validator = {
  employeeValidator,
  phoneValidator,
  nameValidator,
  addressValidator,
  wa10memberValidator,
};

export default Validator;
